import axios from "axios";
import {BASE_DOMAIN, BASE_PATH} from "./config/Url";
import Cookies from "js-cookie";

export const DG_axios = axios.create({
    baseURL: `${BASE_PATH}`,
    headers: {
        "Content-Type": "application/json"
    },
    withCredentials: true
});
export const getLocalOauth2Token = () => {
    const oauth2Token = Cookies.get("oauth2Token");
    return `Bearer ${oauth2Token}`;
}

export const getLocalAccessToken = () => {
    return Cookies.get("accessToken");
}

export const updateLocalAccessToken = (accessToken) => {
    Cookies.set("accessToken", accessToken, {expires: 30, domain: BASE_DOMAIN});
}
export const getLanguage = () => {
    return Cookies.get("language") || "vi"
}
